(function () {
  'use strict';

  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('doubleSectorPriorToDayTurnaround', [
      'ui.router'
    ]);
}());
